import React from 'react'
import _ from 'lodash'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import { Clipboard, TouchableOpacity } from 'react-native'

import * as util from 'x/utils/util'
import { getStoreSelected, getSelectedProduct } from 'x/redux/selectors'
import * as NavActions from 'x/utils/navigation'
import * as api from 'x/utils/api'
import p from 'x/config/platform-specific'

import {
  IProductDetailItemMap,
  IVariantMkpInfo,
  ISelectedStoreMap,
  IProductDetailVariant,
  IComputedVariantMkpInfo,
  IAnyObject,
  INavHeaderButtonProps,
  IProductBundleMapperNavParams,
  IXScreenProps,
  ISearchProductItem,
  IBundleProductMapping,
  IBundleProductVariant,
  IProductBundleQtyMapping,
  IProductDetailBundledVariant,
  IProductDetailAssembledVariant,
  IOnSubmitBundleMapperMappingsParams,
} from 'x/index'

import XText from 'xui/components/XText'
import XCard from 'xui/components/XCard'
import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import MkpLogo from 'xui/components/MkpLogo'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCustomHeader from 'xui/components/XCustomHeader'
import XImage from 'xui/components/XImage'
import Box from 'xui/components/Box'
import XButton from 'xui/components/XButton'
import XIcon from 'xui/components/XIcon'
import XSellyLogo from 'xui/components/XSellyLogo'
import XInput from 'xui/components/XInput'
import XNumericInput from 'xui/components/XNumericInput'
import HelpButton from 'xui/components/HelpButton'
import AddIcon from 'xui/components/AddIcon'
import ProductBundleContainer from 'xui/components/ProductBundleContainer'
import XKeyboardAvoidingView from 'xui/components/XKeyboardAvoidingView'

interface IProps extends IXScreenProps<IProductBundleMapperNavParams> {
  selectedStore: ISelectedStoreMap
}

interface IState {
  isInitialized?: boolean
  // variants: IProductDetailVariant[]

  // selectedBundledProducts: ISearchProductItem[] //  เก็บสินค้าที่เลือกเพิ่มในเซต
  selectedBundleProductVariant: IBundleProductVariant //  เก็บข้อมูลของ variant

  editingPpName?: string

  editingBundledPpIds: number[] //  เก็บสินค้าที่เลือกเพิ่มในเซต
  editingBundleMappings: {
    [ppId: number]: IProductBundleQtyMapping
  } //  เก็บการแมพสินค้าที่เลือกเพิ่มในเซต

  //  เอาไว้แสดงเฉพาะตัวที่สนใจ (pp_id ส่งมาจาก nav param)
  // visibleVariantIndex?: number
  type: 'bundle' | 'assembly'
  mode: 'detail' | 'edit' | 'create' | 'convert' | 'create-edit'

  isDirty?: boolean
}

class ProductBundleMapper extends React.Component<IProps, IState> {
  static displayName = 'ProductBundleMapper'

  constructor(props) {
    super(props)
    this.state = {
      isInitialized: false,
      type: 'bundle',
      mode: 'detail',

      // selectedBundledProducts: [],
      selectedBundleProductVariant: null,
      editingBundledPpIds: [],
      editingBundleMappings: {},
      editingPpName: '',
    }
  }

  async componentDidMount() {
    await this._initialize()
    await util.delay(100)
    await this._fetchRelatedProductDetail()
    await util.delay(100)
    await util.setStatePromise(this, { isInitialized: true })
    // await this._initialNav()
    console.log('componentDidMount selectedBundleProductVariant => ', this.state.selectedBundleProductVariant)
  }

  _initialize = async () => {
    const mode = util.getNavParam(this.props, 'mode')
    const type = util.getNavParam(this.props, 'type')

    if (!mode || !type) {
      p.op.alert('ข้อมูลไม่ครบ', 'ไม่พบพารามิเตอร์ที่จำเป็น กรุณาลองใหม่อีกครั้ง')
      this._goBack()
      return
    }

    const initialBundleProductVariant = util.getNavParam(this.props, 'initialBundleProductVariant')
    console.log('_initialize initialBundleProductVariant => ', initialBundleProductVariant)
    if (
      initialBundleProductVariant &&
      'bundle_product_mappings' in initialBundleProductVariant &&
      _.isArray(initialBundleProductVariant.bundle_product_mappings)
    ) {
      const editingBundledPpIds = initialBundleProductVariant.bundle_product_mappings.map((mapping) => mapping.pp_id) || []
      const editingBundleMappings: IAnyObject = {}
      initialBundleProductVariant.bundle_product_mappings.forEach((mapping) => {
        editingBundleMappings[mapping.pp_id] = mapping
      })

      await util.setStatePromise(this, {
        editingBundledPpIds,
        editingBundleMappings,
        selectedBundleProductVariant: initialBundleProductVariant,
        editingPpName: initialBundleProductVariant.pp_name || '',
      })
    }

    if (
      initialBundleProductVariant &&
      'assembly_product_mappings' in initialBundleProductVariant &&
      _.isArray(initialBundleProductVariant.assembly_product_mappings)
    ) {
      const editingBundledPpIds = initialBundleProductVariant.assembly_product_mappings.map((mapping) => mapping.pp_id) || []
      const editingBundleMappings: IAnyObject = {}
      initialBundleProductVariant.assembly_product_mappings.forEach((mapping) => {
        editingBundleMappings[mapping.pp_id] = mapping
      })

      await util.setStatePromise(this, {
        editingBundledPpIds,
        editingBundleMappings,
        selectedBundleProductVariant: initialBundleProductVariant,
      })
    }

    await util.setStatePromise(this, { mode, type })
  }

  _initialNav = async () => {
    const { type, mode } = this.state

    if (mode === 'create') {
      this._navToSearchProductVariantListView()
    }
  }

  _fetchRelatedProductDetail = async () => {
    const { type } = this.state
    const product_bundle_id = util.getNavParam(this.props, 'product_bundle_id')
    const product_assembly_id = util.getNavParam(this.props, 'product_assembly_id')
    // console.log('_fetchRelatedProductDetail type => ', type)
    // console.log('_fetchRelatedProductDetail product_bundle_id => ', product_bundle_id)
    // console.log('_fetchRelatedProductDetail product_assembly_id => ', product_assembly_id)

    if (type === 'bundle') {
      await this._fetchProductBundleDetail()
    }

    if (type === 'assembly') {
      await this._fetchProductAssemblyDetail()
    }
  }

  _fetchProductBundleDetail = async () => {
    const store_id = util.getNavParam(this.props, 'store_id')
    const product_bundle_id = util.getNavParam(this.props, 'product_bundle_id')
    if (!product_bundle_id) {
      return
    }

    try {
      const res = await api.fetchProductBundleDetail({ store_id, product_bundle_id })
      await this._loadProductBundleDetail(res)
    } catch (error) {
      p.op.showToast('ไม่พบข้อมูลสินค้าเซต', 'danger')
    }
  }

  _fetchProductAssemblyDetail = async () => {
    const store_id = util.getNavParam(this.props, 'store_id')
    const product_assembly_id = util.getNavParam(this.props, 'product_assembly_id')
    if (!product_assembly_id) {
      return
    }

    try {
      const res = await api.fetchProductAssemblyDetail({ store_id, product_assembly_id })
      await this._loadProductBundleDetail(res)
    } catch (error) {
      p.op.showToast('ไม่พบข้อมูลสินค้าเซต', 'danger')
    }
  }

  _loadProductBundleDetail = async (pdbv: IProductDetailBundledVariant | IProductDetailAssembledVariant) => {
    if (pdbv && 'pp_id' in pdbv) {
      let editingBundledPpIds = []
      const editingBundleMappings: IAnyObject = {}

      if (_.isArray(pdbv.bundle_product_mappings)) {
        editingBundledPpIds = pdbv.bundle_product_mappings.map((mapping) => mapping.pp_id) || []
        pdbv.bundle_product_mappings.forEach((mapping) => {
          editingBundleMappings[mapping.pp_id] = mapping
        })
      }

      if (_.isArray(pdbv.assembly_product_mappings)) {
        editingBundledPpIds = pdbv.assembly_product_mappings.map((mapping) => mapping.pp_id) || []
        pdbv.assembly_product_mappings.forEach((mapping) => {
          editingBundleMappings[mapping.pp_id] = mapping
        })
      }

      await util.setStatePromise(this, {
        editingBundledPpIds,
        editingBundleMappings,
        selectedBundleProductVariant: pdbv,
      })
    }
  }

  _isDirty = () => {
    const { mode, isDirty } = this.state

    if (mode === 'detail') {
      return false
    }

    return isDirty
  }

  _goBack = async (checkDirty = false) => {
    // Check dirty state before go back
    let isUserConfirmed = true
    if (checkDirty && this._isDirty()) {
      isUserConfirmed = await p.op.isUserConfirm('คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณต้องการออกจากหน้านี้โดยไม่บันทึกหรือไม่?')
    }

    if (!isUserConfirmed) {
      return
    }

    util.navGoBack(this.props)
  }

  _getHeaderTitle = () => {
    const { mode, type } = this.state
    let headerTitle

    const contextText = type === 'bundle' ? 'สินค้าเซต' : 'สินค้าประกอบ'

    headerTitle = `รายละเอียด${contextText}`

    if (mode === 'edit') {
      headerTitle = `แก้ไข${contextText}`
    }

    if (mode === 'create' || mode === 'create-edit') {
      headerTitle = `สร้าง${contextText}`
    }

    if (mode === 'convert') {
      headerTitle = `เปลี่ยนเป็น${contextText}`
    }

    return headerTitle
  }

  _onSave = async () => {
    const { mode, type } = this.state
    let opText
    const contextText = type === 'bundle' ? 'สินค้าเซต' : 'สินค้าประกอบ'

    if (mode === 'edit') {
      opText = `แก้ไข${contextText}`
    }

    if (mode === 'create' || mode === 'create-edit') {
      opText = `สร้าง${contextText}`
    }

    if (mode === 'convert') {
      opText = `เปลี่ยนเป็น${contextText}`
    }

    if (_.includes(['edit', 'convert'], mode)) {
      const isUserComfirmed = await p.op.isUserConfirm(`คุณต้องการ${opText} ใช่หรือไม่?`, `${opText}`, 'ยืนยัน', 'ยกเลิก')
      if (!isUserComfirmed) {
        return
      }
    }

    this._doSave()
  }

  _doSave = async () => {
    const { editingBundledPpIds, editingBundleMappings, mode, type } = this.state
    const bundleMappings: IProductBundleQtyMapping[] = editingBundledPpIds.map((ppId) => {
      const mapping = editingBundleMappings[ppId]

      if ('unit_price_weight' in mapping && !_.isNil(mapping.unit_price_weight)) {
        // @ts-ignore
        mapping.unit_price_weight = parseFloat(mapping.unit_price_weight)
      }

      return {
        ...editingBundleMappings[ppId],
      }
    })
    console.log('bundleMappings => ', bundleMappings)

    if (type === 'bundle' && mode === 'edit') {
      // Handle edit mode for bundle
      await this._editBundleProductMappings(bundleMappings)
      return
    }

    if (type === 'bundle' && mode === 'convert') {
      // Handle convert mode for bundle
      await this._convertBundleProductMappings(bundleMappings)
      return
    }

    if (type === 'assembly' && mode === 'edit') {
      // Handle edit mode for assembly
      await this._editAssemblyProductMappings(bundleMappings)
      return
    }

    if (type === 'assembly' && mode === 'convert') {
      // Handle convert mode for assembly
      await this._convertAssemblyProductMappings(bundleMappings)
      return
    }

    await this._doOnSubmitCallback(bundleMappings)
  }

  _doOnSubmitCallback = async (bundleMappings: IProductBundleQtyMapping[]) => {
    const { editingPpName } = this.state

    const onSubmitMappings = util.getNavParam(this.props, 'onSubmitMappings')

    if (_.isFunction(onSubmitMappings)) {
      try {
        const params: IOnSubmitBundleMapperMappingsParams = { mappings: bundleMappings }
        if (editingPpName && editingPpName.length > 0) {
          params.name = editingPpName
        }
        await onSubmitMappings(params)
        p.op.showToast('บันทึกสำเร็จ', 'success')
        this._goBack()
      } catch (error) {
        p.op.showToast(JSON.stringify(error), 'danger')
      }
    }
  }

  _editBundleProductMappings = async (bundleMappings: IProductBundleQtyMapping[]) => {
    const { selectedBundleProductVariant } = this.state
    const navParams = util.getNavParams(this.props)
    // console.log('_editBundleProductMappings navParams => ', navParams)
    const ppId = util.getNavParam(this.props, 'pp_id')
    const onSaveSuccess = util.getNavParam(this.props, 'onSaveSuccess')

    if (!('product_bundle_id' in selectedBundleProductVariant)) {
      p.op.showToast('ไม่พบข้อมูลสินค้าเซต', 'danger')
      return
    }

    try {
      const res = await api.editProductBundle({
        store_id: util.getNavParam(this.props, 'store_id'),
        product_product_id: ppId,
        product_bundle_id: selectedBundleProductVariant.product_bundle_id,
        bundle_product_mappings: bundleMappings,
      })

      if (res && 'product_bundle_id' in res) {
        await this._loadProductBundleDetail(res)

        if (_.isFunction(onSaveSuccess)) {
          onSaveSuccess(res)
        }

        this._goBack()
        return
      }
    } catch (error) {
      console.log('Error editing bundle => ', error)
      p.op.showToast(JSON.stringify(error), 'danger')
    }
  }

  _convertBundleProductMappings = async (bundleMappings: IProductBundleQtyMapping[]) => {
    const { selectedBundleProductVariant } = this.state
    const ppId = util.getNavParam(this.props, 'pp_id')
    const onConvertSuccess = util.getNavParam(this.props, 'onConvertSuccess')
    const isShowWarningIfHasOrdered = util.getNavParam(this.props, 'isShowWarningIfHasOrdered')
    let isUserConfirmed = true

    if (isShowWarningIfHasOrdered || (selectedBundleProductVariant && 'has_ordered' in selectedBundleProductVariant)) {
      isUserConfirmed = await p.op.isUserConfirm(
        'สินค้านี้มีการใช้เปิดออเดอร์ไปแล้ว ',
        'การเปลี่ยนสินค้านี้เป็นสินค้าเซต จะไม่ส่งผลกระทบต่อข้อมูลออเดอร์ที่ผ่านมา จะมีผลกระทบเฉพาะออเดอร์ในอนาคตเท่านั้น คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?'
      )
    }

    if (!isUserConfirmed) {
      return
    }

    try {
      console.log('Converting bundle with ppId => ', ppId)
      console.log('Converting bundle with mappings => ', bundleMappings)
      const res = await api.convertProductBundle({
        store_id: util.getNavParam(this.props, 'store_id'),
        product_product_id: ppId,
        bundle_product_mappings: bundleMappings,
      })

      if (res && 'product_bundle_id' in res) {
        await this._loadProductBundleDetail(res)

        if (_.isFunction(onConvertSuccess)) {
          onConvertSuccess(res)
        }

        this._goBack()
        return
      }
    } catch (error) {
      console.log('Error converting to bundle => ', error)
      p.op.showToast(JSON.stringify(error), 'danger')
    }
  }

  _editAssemblyProductMappings = async (bundleMappings: IProductBundleQtyMapping[]) => {
    const { selectedBundleProductVariant } = this.state
    const ppId = util.getNavParam(this.props, 'pp_id')
    const onSaveSuccess = util.getNavParam(this.props, 'onSaveSuccess')

    if (!('product_assembly_id' in selectedBundleProductVariant)) {
      p.op.showToast('ไม่พบข้อมูลสินค้าประกอบ', 'danger')
      return
    }

    try {
      const res = await api.editProductAssembly({
        store_id: util.getNavParam(this.props, 'store_id'),
        product_product_id: ppId,
        product_assembly_id: selectedBundleProductVariant.product_assembly_id,
        assembly_product_mappings: bundleMappings,
      })

      if (res && 'product_assembly_id' in res) {
        await this._loadProductBundleDetail(res)

        if (_.isFunction(onSaveSuccess)) {
          onSaveSuccess(res)
        }

        this._goBack()
        return
      }
    } catch (error) {
      p.op.showToast(JSON.stringify(error), 'danger')
    }
  }

  _convertAssemblyProductMappings = async (bundleMappings: IProductBundleQtyMapping[]) => {
    // const { selectedBundleProductVariant } = this.state
    const ppId = util.getNavParam(this.props, 'pp_id')
    const onConvertSuccess = util.getNavParam(this.props, 'onConvertSuccess')

    try {
      console.log('Converting assembly with mappings => ', bundleMappings)
      const res = await api.convertProductAssembly({
        store_id: util.getNavParam(this.props, 'store_id'),
        product_product_id: ppId,
        assembly_product_mappings: bundleMappings,
      })

      if (res && 'product_assembly_id' in res) {
        await this._loadProductBundleDetail(res)

        if (_.isFunction(onConvertSuccess)) {
          onConvertSuccess(res)
        }

        this._goBack()
        return
      }
    } catch (error) {
      console.log('Error converting assembly => ', error)
      p.op.showToast(JSON.stringify(error), 'danger')
    }
  }

  // _getHeaderLeftProps = (): INavHeaderButtonProps => {
  //   const { mode } = this.state
  //   let headerLeftProps: INavHeaderButtonProps = { backIcon: true, onPressItem: this._goBack }

  //   if (mode === 'detail') {
  //     return headerLeftProps
  //   }

  //   headerLeftProps = {
  //     label: 'บันทึก',
  //     onPressItem: this._onSave,
  //   }

  //   return headerLeftProps
  // }

  _getHeaderRightProps = (): INavHeaderButtonProps => {
    // const { mode } = this.state

    // if (mode === 'detail') {
    //   return null
    // }

    // return {
    //   label: 'ยกเลิก',
    //   onPressItem: this._goBack,
    // }

    return null
  }

  _renderCustomHeader = () => {
    const { mode } = this.state

    return (
      <XCustomHeader
        title={this._getHeaderTitle()}
        // headerLeftProps={this._getHeaderLeftProps()}
        headerLeftProps={{ backIcon: true, onPressItem: () => this._goBack(true) }}
        headerRightProps={this._getHeaderRightProps()}
      />
    )
  }

  _renderSearchBar = () => {
    const { selectedStore } = this.props

    return (
      <HStack w='full' alignItems='center' justifyContent='space-between' px='4' py='2'>
        <XInput placeholder='ค้าหาสินค้าในเซต' w='full' />
      </HStack>
    )
  }

  _convertProductListItemToProductBundleQtyMapping = (item: ISearchProductItem): IProductBundleQtyMapping => {
    return {
      pp_id: item.v[0].i,
      pt_name: item.n,
      pp_name: item.v[0].n || '',
      sku: item.v[0].sku || '',
      upc: item.v[0].upc || '',
      tiny_img_url: item.v[0].img_url || item.t[0] || '',
      qty: 1, // default to 1, can be changed later
      unit_price_weight: '0',
      // unit_cost_weight: '0',
    }
  }

  _onAddProductItemToBundlePressed = (productItem: ISearchProductItem) => {
    // const { selectedBundledProducts } = this.state

    // const newSelectedProducts = [...selectedBundledProducts, productItem]
    // this.setState({ selectedBundledProducts: newSelectedProducts })

    const { editingBundledPpIds: oldPpIds, editingBundleMappings: oldMappings, selectedBundleProductVariant, type } = this.state
    const focusedPpId = util.getNavParam(this.props, 'pp_id')
    const contextText = type === 'bundle' ? 'สินค้าเซต' : 'สินค้าประกอบ'

    if (focusedPpId && focusedPpId === productItem.v[0].i) {
      // ถ้า id ตรงกัน ให้ทำการเพิ่มสินค้าเข้าไปในเซต
      p.op.alert(
        'ไม่สามารถเพิ่มสินค้านี้ได้',
        `ไม่สามารถเพิ่มสินค้านี้ลงใน${contextText}ได้ เนื่องจากเป็นสินค้าหลักของ${contextText}อยู่แล้ว`
      )
      return
    }

    const ppId = productItem.v[0].i
    const editingBundledPpIds = oldPpIds.includes(ppId) ? oldPpIds : [...oldPpIds, ppId]
    let editingBundleMappings: {
      [ppId: number]: IProductBundleQtyMapping
    }

    if (oldMappings[ppId]) {
      //  ถ้ามี ppId นี้อยู่แล้ว ให้ไม่ทำอะไร
      editingBundleMappings = {
        ...oldMappings,
        [ppId]: {
          ...oldMappings[ppId], //  คัดลอกข้อมูลจาก oldMappings[ppId]
          qty: oldMappings[ppId].qty + 1, //  เพิ่ม qty ขึ้น 1
        },
      }
    } else {
      editingBundleMappings = {
        ...oldMappings,
        [ppId]: this._convertProductListItemToProductBundleQtyMapping(productItem), //  เปลี่ยน item เป็น IProductBundleQtyMapping
      }
    }

    this.setState({ editingBundledPpIds, editingBundleMappings, isDirty: true }, () => {
      const listItemsText = editingBundledPpIds
        .map((ppId) => {
          const item = editingBundleMappings[ppId]
          const vName = item.pp_name && item.pp_name.length > 0 ? item.pp_name : null
          const productName = `${item.pp_name}${vName ? ` (${vName})` : ''}`
          return `${item.qty}x ${productName}`
        })
        .join('\n')

      const summaryText = `เพิ่มสินค้า ${productItem.n} ในเซตสำเร็จ\n\n${listItemsText}`
      p.op.showToast(summaryText, 'success')
    })
  }

  _navToSearchProductVariantListView = () => {
    const { navigation, selectedStore } = this.props
    const { type } = this.state
    const store_id = util.getNavParam(this.props, 'store_id')
    const focusedPpId = util.getNavParam(this.props, 'pp_id')
    const renderNavReference = util.getNavParam(this.props, 'renderNavReference')
    const buttonText = type === 'bundle' ? 'เพิ่มในสินค้าเซต' : 'เพิ่มในสินค้าประกอบ'

    navigation.dispatch(
      NavActions.navToSearchProductVariantListView({
        store_id,
        excluded_pp_ids: [focusedPpId],

        defaultFilter: {
          isBundleProduct: false,
          isAssemblyProduct: false,
          isStandardProduct: true,
          isProductVariantTypeFilterHidden: true, //  ซ่อนตัวเลือกประเภทสินค้า
        },

        renderNavReference,
        onProductItemPressed: this._onAddProductItemToBundlePressed,
        productItemButtonText: buttonText,
        isNavToProductDetailDisabled: true,
        isBundleOperationsDisabled: true,
      })
    )
  }

  _navToStockListView = () => {
    const { selectedBundleProductVariant } = this.state
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')

    let ppIds = []

    if ('bundle_product_mappings' in selectedBundleProductVariant && _.isArray(selectedBundleProductVariant.bundle_product_mappings)) {
      ppIds = selectedBundleProductVariant.bundle_product_mappings.map((mapping) => mapping.pp_id)
    }

    if ('assembly_product_mappings' in selectedBundleProductVariant && _.isArray(selectedBundleProductVariant.assembly_product_mappings)) {
      ppIds = selectedBundleProductVariant.assembly_product_mappings.map((mapping) => mapping.pp_id)
    }

    navigation.dispatch(
      NavActions.navToSearchProductVariantListView({
        store_id: storeId,
        pp_ids: ppIds,
        isNavToProductDetailDisabled: true,
        isBundleOperationsDisabled: true,
      })
    )
  }

  _navToVariantStockListView = (ppId: number) => {
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToSearchProductVariantListView({
        store_id: storeId,
        pp_ids: [ppId],
        isNavToProductDetailDisabled: true,
        isBundleOperationsDisabled: true,
      })
    )
  }

  _renderNavToSearchProductVariantListViewButton = () => {
    const { mode } = this.state
    if (mode !== 'detail') {
      return null
    }

    return (
      <XButton w='118px' h='24px' size='xs' variant='outline' leftIcon={<XIcon name='albums' />} onPress={this._navToStockListView}>
        ดูรายการสต๊อก
      </XButton>
    )
  }

  _renderAddProductToBundleButton = () => {
    const { mode, type } = this.state
    if (mode === 'detail') {
      return null
    }
    const buttonText = type === 'bundle' ? p.op.t('bundle.addProductToBundle') : p.op.t('assembly.addProductToAssembly')
    return (
      <TouchableOpacity onPress={this._navToSearchProductVariantListView}>
        <HStack
          // h={type === 'bundle' ? '28px' : '44px'}
          // w={type === 'bundle' ? '140px' : '120px'}
          w={'140px'}
          alignItems='center'
          justifyContent='center'
          borderWidth='1'
          borderColor='primary.500'
          borderRadius='lg'
          bg='muted.100'
          space='1'
        >
          <HStack w='28px' h='28px' alignItems='center' justifyContent='center'>
            <XIcon name='add' />
          </HStack>
          <XText
            flex={1}
            variant='primary'
            // fontSize={type === 'bundle' ? 'sm' : 'xs'}
          >
            {buttonText}
          </XText>
        </HStack>
      </TouchableOpacity>
    )

    // const buttonText = type === 'bundle' ? 'เพิ่มสินค้าเข้าเซต' : 'เพิ่มสินค้าเข้าในสินค้าประกอบ'

    // return (
    //   <XButton h='24px' w='100px' size='xs' variant='outline' leftIcon={<AddIcon />} onPress={this._navToSearchProductVariantListView}>
    //     {/* {buttonText} */}
    //     เพิ่มสินค้า
    //   </XButton>
    // )

    // return (
    //   <HStack w='full' alignItems='center' justifyContent='center' px='4' py='2'>
    //     <XButton w='full' onPress={this._navToSearchProductVariantListView}>
    //       {buttonText}
    //     </XButton>
    //   </HStack>
    // )
  }

  _renderFooter = () => {
    const { mode, type, editingBundledPpIds, isInitialized } = this.state
    if (mode === 'detail') {
      return null
    }

    let buttonText
    const contextText = type === 'bundle' ? 'สินค้าเซต' : 'สินค้าประกอบ'

    if (mode === 'edit') {
      buttonText = `บันทึก${contextText}`
    }

    if (mode === 'create' || mode === 'create-edit') {
      buttonText = `สร้าง${contextText}`
    }

    if (mode === 'convert') {
      buttonText = `เปลี่ยนเป็น${contextText}`
    }

    const isDisabled = !isInitialized || editingBundledPpIds.length === 0

    return (
      <HStack w='full' px='2' py='2' borderTopWidth='1' borderTopColor='gray.200' bg='white'>
        <XButton w='full' onPress={this._onSave} isDisabled={isDisabled} disabled={isDisabled}>
          {buttonText}
        </XButton>
      </HStack>
    )
  }

  _removeSelectedProduct = (ppId: number) => {
    // const { selectedBundledProducts } = this.state

    // const newSelectedProducts = selectedBundledProducts.filter((_, i) => i !== index)
    // this.setState({ selectedBundledProducts: newSelectedProducts })
    const { editingBundledPpIds: oldPpIds, editingBundleMappings: oldMappings } = this.state

    const editingBundledPpIds = oldPpIds.filter((id) => id !== ppId)
    const editingBundleMappings = _.omit(oldMappings, ppId)

    this.setState({ editingBundledPpIds, editingBundleMappings, isDirty: true })
  }

  _renderSelectedProductPpId = (ppId: number, index: number) => {
    const { editingBundleMappings } = this.state
    const productItem = editingBundleMappings[ppId]
    if (_.isNil(productItem) || _.isEmpty(productItem)) {
      return null
    }

    return this._renderBundleProductMappingItem(productItem, index)
  }

  _renderProductVariantBundleMappingQty = (pbm: IProductBundleQtyMapping) => {
    const { mode, type } = this.state
    if (mode === 'detail') {
      return (
        <VStack w='full' space='1'>
          {type === 'bundle' ? (
            <HStack w='full' alignItems='center' space='1'>
              <HStack w='220px' alignItems='center' space='1'>
                <XText variant='inactive'>ราคาขายสัดส่วนต่อหน่วย</XText>
              </HStack>

              <XText flex={1} textAlign='right'>
                {pbm.unit_price_weight || '0'}
              </XText>
            </HStack>
          ) : null}

          {/* <HStack w='full' alignItems='center' space='1'>
            <HStack w='220px' alignItems='center' space='1'>
              <XText variant='inactive'>ต้นทุนสัดส่วนต่อหน่วย</XText>
            </HStack>

            <XText flex={1} textAlign='right'>
              {pbm.unit_cost_weight}
            </XText>
          </HStack> */}

          <HStack w='full' alignItems='center' space='1'>
            <HStack w='220px' alignItems='center' space='1'>
              <XText variant='inactive'>จำนวน (ต่อเซต)</XText>
            </HStack>

            <XText flex={1} bold textAlign='right'>
              {pbm.qty}
            </XText>
          </HStack>
        </VStack>
      )
    }

    return (
      <VStack w='full' space='1'>
        {type === 'bundle' ? (
          <HStack w='full' alignItems='center' space='1'>
            <HStack w='220px' alignItems='center' space='1'>
              <XText variant='inactive'>ราคาขายสัดส่วนต่อหน่วย</XText>

              <HelpButton title='น้ำหนักของราคา' message='น้ำหนักของราคาสินค้าในเซตนี้ จะถูกใช้ในการคำนวณราคาขายและต้นทุนของสินค้าเซต' />
            </HStack>

            <HStack flex={1} alignItems='center' justifyContent='flex-end'>
              <XInput
                w='150px'
                isMoney
                value={pbm.unit_price_weight || '0'}
                keyboardType='numeric'
                textAlign='right'
                onChangeText={(value) => {
                  const { editingBundleMappings } = this.state
                  const newMappings = {
                    ...editingBundleMappings,
                    [pbm.pp_id]: {
                      ...editingBundleMappings[pbm.pp_id],
                      unit_price_weight: value,
                    },
                  }
                  this.setState({ editingBundleMappings: newMappings, isDirty: true })
                }}
              />
            </HStack>
          </HStack>
        ) : null}

        {/* <HStack w='full' alignItems='center' space='1'>
          <HStack w='220px' alignItems='center' space='1'>
            <XText variant='inactive'>ต้นทุนสัดส่วนต่อหน่วย</XText>

            <HelpButton title='น้ำหนักของต้นทุน' message='น้ำหนักของต้นทุนสินค้าที่ใช้ในการคำนวณต้นทุนของสินค้าเซต' />
          </HStack>

          <HStack flex={1} alignItems='center' justifyContent='flex-end'>
            <XInput
              w='150px'
              isMoney
              value={pbm.unit_cost_weight}
              keyboardType='numeric'
              textAlign='right'
              onChangeText={(value) => {
                const { editingBundleMappings } = this.state
                const newMappings = {
                  ...editingBundleMappings,
                  [pbm.pp_id]: {
                    ...editingBundleMappings[pbm.pp_id],
                    unit_cost_weight: value,
                  },
                }
                this.setState({ editingBundleMappings: newMappings })
              }}
            />
          </HStack>
        </HStack> */}

        <HStack w='full' alignItems='center' space='1'>
          <HStack w='220px' alignItems='center' space='1'>
            <XText variant='inactive'>จำนวน (ต่อเซต)</XText>
          </HStack>

          <HStack flex={1} alignItems='center' justifyContent='flex-end'>
            <XNumericInput
              w='150px'
              value={pbm.qty}
              keyboardType='numeric'
              onChangeValue={(value) => {
                const { editingBundleMappings } = this.state
                const newMappings = {
                  ...editingBundleMappings,
                  [pbm.pp_id]: {
                    ...editingBundleMappings[pbm.pp_id],
                    qty: value,
                  },
                }
                this.setState({ editingBundleMappings: newMappings, isDirty: true })
              }}
              minValue={1}
            />
          </HStack>
        </HStack>
      </VStack>
    )
  }

  _navToProductDetail = (productId: number) => {
    const { navigation } = this.props
    const storeId = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToProductViewMyStore({
        store_id: storeId,
        product_id: productId,
        // onSuccessAddProductCallback: this._setDirty,
        // onSuccessDeleteProductCallback: this._setDirty,
        // onSuccessEditProductCallback: this._setDirty,
      })
    )
  }

  _renderBundleProductMappingItem = (pbm: IProductBundleQtyMapping, index: number) => {
    const isNavToProductDetailDisabled = util.getNavParam(this.props, 'isNavToProductDetailDisabled', false)
    // const { selectedBundledProducts } = this.state
    const { mode } = this.state
    const { pt_id, pp_id, pp_name, pt_name, tiny_img_url, sku, upc } = pbm

    return (
      <XCard w='full' key={`${index}_${pp_id}`}>
        <VStack w='full' p='2' minH='12' alignItems='center' space='1'>
          <HStack w='full' minH='12' space='1.5'>
            <HStack
              w='48px'
              h='48px'
              alignItems='center'
              justifyContent='center'
              borderWidth='1'
              borderColor='gray.200'
              borderRadius='lg'
              overflow='hidden'
            >
              <XImage w='48px' h='48px' source={{ uri: tiny_img_url }} />
            </HStack>

            <VStack flex={1} space='1'>
              <XText variant='inactive' numberOfLines={1}>
                {pt_name}
              </XText>
              <XText numberOfLines={1}>{pp_name}</XText>
              {sku && sku.length > 0 && (
                <XText variant='inactive' fontSize='xs'>
                  SKU: {sku}
                </XText>
              )}
              {upc && upc.length > 0 && (
                <XText variant='inactive' fontSize='xs'>
                  UPC: {upc}
                </XText>
              )}
            </VStack>

            {mode === 'detail' ? null : (
              <TouchableOpacity onPress={() => this._removeSelectedProduct(pp_id)}>
                <HStack w='24px' h='24px' alignItems='center' justifyContent='center'>
                  <XIcon name='trash' variant='danger' />
                </HStack>
              </TouchableOpacity>
            )}

            {/* {mode === 'detail' && !isNavToProductDetailDisabled ? (
              <TouchableOpacity onPress={() => this._navToProductDetail(pt_id)}>
                <VStack alignItems='center'>
                  <XIcon name='information-circle-outline' />
                  <XText variant='primary' fontSize='3xs'>
                    ดูสินค้า
                  </XText>
                </VStack>
              </TouchableOpacity>
            ) : null} */}
            {mode === 'detail' && !isNavToProductDetailDisabled ? (
              <XText fontSize='xs' color='blue.500' underline onPress={() => this._navToProductDetail(pt_id)}>
                ดูสินค้า
              </XText>
            ) : null}

            <XText fontSize='xs' color='blue.500' underline onPress={() => this._navToVariantStockListView(pp_id)}>
              ดูสต๊อก
            </XText>
          </HStack>
          {this._renderProductVariantBundleMappingQty(pbm)}

          <HStack w='full' alignItems='center' space='1'>
            <XText fontSize='xs' variant='inactive'>{`#${index + 1}`}</XText>
            <XText fontSize='xs' variant='inactive' onPress={() => this._handlePressProductID(pp_id)}>{`ID:${pp_id}`}</XText>
          </HStack>
        </VStack>
      </XCard>
    )
  }

  _handlePressProductID = (id: number) => {
    try {
      Clipboard.setString(id.toString())
      p.op.showToast(`คัดลอก ${id} ไปยังคลิปบอร์ดแล้ว`, 'success')
    } catch (error) {
      console.log('_handlePressProductID error => ', error)
    }
  }

  _getSumOfEditingMappingQtyCount = () => {
    const { editingBundleMappings } = this.state
    return Object.values(editingBundleMappings).reduce((sum, mapping) => sum + mapping.qty, 0)
  }

  _renderEditingProductVariantName = () => {
    const { editingPpName, mode, type } = this.state
    if (!_.includes(['create'], mode)) {
      return null
    }

    const contextText = type === 'bundle' ? 'สินค้าเซต' : 'สินค้าประกอบ'

    return (
      <HStack w='full' alignItems='center' space='1' py='1'>
        <XText w='100px' variant='inactive'>
          ชื่อ{contextText}
        </XText>

        <XInput
          flex={1}
          placeholder={`ระบุชื่อ${contextText}`}
          value={editingPpName}
          onChangeText={(text) => this.setState({ editingPpName: text, isDirty: true })}
        />
      </HStack>
    )
  }

  _renderContent = () => {
    // const { selectedBundledProducts } = this.state
    // return selectedBundledProducts.map(this._renderSelectedProductItem)

    const { editingBundledPpIds, type } = this.state
    // const contextText = type === 'bundle' ? 'สินค้าเซต' : 'สินค้าประกอบ'
    const isInContext = type === 'bundle' ? 'รายการสินค้าในเซต' : 'รายการสินค้าที่เป็นส่วนประกอบ'
    const buttonText = type === 'bundle' ? p.op.t('bundle.addProductToBundle') : p.op.t('assembly.addProductToAssembly')
    return (
      <VStack w='full' px='2' pb='3' space='1'>
        {this._renderWarningBanner()}

        {this._renderEditingProductVariantName()}

        <HStack
          w='full'
          // alignItems='center'
          space='1'
        >
          <XText flex={1} variant='inactive'>
            {isInContext}
            {'\n'}({editingBundledPpIds.length} สินค้า {this._getSumOfEditingMappingQtyCount()} ชิ้น)
          </XText>

          {this._renderAddProductToBundleButton()}
          {/* {this._renderNavToSearchProductVariantListViewButton()} */}
        </HStack>

        {editingBundledPpIds.length === 0 && (
          <HStack w='full' h='150px' alignItems='center' justifyContent='center' p='4'>
            <XText variant='inactive'>
              ยังไม่มี{isInContext} กรุณากดปุ่ม *{buttonText}* ด้านบนก่อน
            </XText>
          </HStack>
        )}
        {editingBundledPpIds.map(this._renderSelectedProductPpId)}
      </VStack>
    )
  }

  _renderParentDetail = () => {
    const { selectedBundleProductVariant, mode } = this.state
    if (mode !== 'detail') {
      return null
    }

    if (_.isNil(selectedBundleProductVariant) || _.isEmpty(selectedBundleProductVariant)) {
      return null
    }

    const spv = selectedBundleProductVariant
    const pName = 'pt_name' in spv && !_.isNil(spv.pt_name) ? spv.pt_name : ''
    const hasProductName = pName && pName.length > 0
    const thumbnailUri = spv.tiny_img_url
    const hasProductVariantName = spv.pp_name && spv.pp_name.length > 0

    return (
      <HStack w='full' px='2' py='1' alignItems='center' justifyContent='center'>
        <ProductBundleContainer productBundleItem={spv} renderRightHeader={() => null}>
          <VStack w='full' py='1.5' px='2' space='1' bg='white'>
            <HStack w='full' space='1.5'>
              <VStack w='16' h='16'>
                <XImage w='16' h='16' borderRadius='lg' resizeMode='cover' source={{ uri: thumbnailUri }} />

                <Box position='absolute' top='1' left='1'>
                  <XSellyLogo width={24} height={24} />
                </Box>
              </VStack>

              <VStack flex={1}>
                <HStack w='full'>
                  <VStack flex={1}>
                    <XText w='full' numberOfLines={2}>
                      {hasProductName ? pName : '(ยังไม่มีชื่อสินค้า)'}
                    </XText>
                    {spv.sku && spv.sku !== '' ? (
                      <XText w='full' variant='inactive' numberOfLines={1}>
                        {`SKU: ${spv.sku}`}
                      </XText>
                    ) : null}
                    {spv.upc && spv.upc !== '' ? (
                      <XText w='full' variant='inactive' numberOfLines={1}>
                        {`UPC: ${spv.upc}`}
                      </XText>
                    ) : null}
                  </VStack>
                  <VStack w='100px' alignItems='flex-end'>
                    <XText w='full' textAlign='right' bold numberOfLines={3}>
                      {/* {hasProductVariantName ? spv.pp_name : '(ยังไม่มีชื่อตัวเลือกสินค้า)'} */}
                      {hasProductVariantName ? spv.pp_name : ''}
                    </XText>
                  </VStack>
                </HStack>
              </VStack>
            </HStack>

            <HStack w='full' alignItems='center' space='1'>
              <XText fontSize='xs' variant='inactive' onPress={() => this._handlePressProductID(spv.pp_id)}>{`ID:${spv.pp_id}`}</XText>
            </HStack>
          </VStack>
        </ProductBundleContainer>
      </HStack>
    )
  }

  _renderWarningBanner = () => {
    const { mode, type } = this.state
    const isShowWarningIfHasOrdered = util.getNavParam(this.props, 'isShowWarningIfHasOrdered', false)

    if (isShowWarningIfHasOrdered && mode === 'convert' && type === 'bundle') {
      return (
        <VStack w='full'>
          <VStack w='full' bg='yellow.100' px='2' py='1' borderRadius='18px' space='0.5'>
            <XText color='yellow.900'>
              คำเตือน: หากสินค้านี้เคยถูกสั่งซื้อไปในออเดอร์แล้ว และออเดอร์ยังไม่ถูกบันทึกจัดส่ง
              จำนวนที่สั่งและจัดส่งในออเดอร์เหล่านั้นจะไม่ถูกนำมาใช้ในการคำนวณจำนวนของ *คงเหลือ* และ *พร้อมขาย* หลังการเปลื่ยนเป็นสินค้าเซต
            </XText>
            <XText color='yellow.900' py='2'>
              โดยเมื่อยืนยันการ *เปลื่ยนเป็นสินค้าเซต* จำนวน *คงเหลือ* และ *พร้อมขาย* จะถูกคำนวณใหม่ตามสินค้าในเซต
            </XText>
            {/*
            <XText color='yellow.900'>การเปลี่ยนสินค้านี้เป็นสินค้าเซต อาจส่งผลกระทบต่อคำสั่งซื้อที่มีการสั่งซื้อสินค้าไปแล้ว</XText>
            <XText color='yellow.900'>- คงเหลือ และ พร้อมขาย สำหรับออเดอร์ที่สร้างก่อนเปลี่ยนเป็นสินค้าเซต จะไม่ถูกนำมาอัพเดท</XText>
            <XText color='yellow.900'>- คงเหลือ และ พร้อมขาย สำหรับออเดอร์ที่สร้างหลังจากเปลี่ยนเป็นสินค้าเซต จะถูกนำอัพเดทตามปกติ</XText>
            <XText color='yellow.900'>- คงเหลือ และ พร้อมขาย จะถูกคำนวณใหม่ตามสินค้าในเซตทันทีที่เปลี่ยนเป็นสินค้าเซตเสร็จ</XText>
            <XText color='yellow.900'>- หากสินค้ามีสถานะ ติดจอง จะถูกรวมทั้ง จากออเดอร์ที่สร้าง ก่อนและหลัง เปลี่ยนเป็นสินค้าเซต</XText> */}
          </VStack>
        </VStack>
      )
    }

    return null
  }

  render() {
    const { isInitialized } = this.state
    if (!isInitialized) {
      return null
    }

    const renderNavReference = util.getNavParam(this.props, 'renderNavReference')

    return (
      <XKeyboardAvoidingView>
        <XContainer>
          {this._renderCustomHeader()}

          {_.isFunction(renderNavReference) ? (
            <HStack w='full' p='2'>
              {renderNavReference()}
            </HStack>
          ) : null}

          {this._renderParentDetail()}
          {/* {this._renderSearchBar()} */}

          <XContent style={{ backgroundColor: 'white' }}>{this._renderContent()}</XContent>
          {this._renderFooter()}
        </XContainer>
      </XKeyboardAvoidingView>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getStoreSelected(state),
    // selectedProduct: getSelectedProduct(state),
    // mkpChannels: getMkpChannels(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(ProductBundleMapper)
